<template>
  <div class="order-balance-details">
    <h3 class="balance-section-title">资金变动</h3>
    <div v-if="!visibleChanges.length" class="balance-empty">暂无资金变动</div>
    <div v-for="(change, index) in visibleChanges" :key="index" class="balance-stage">
      <span class="balance-title">{{ orderBalanceTitle(change) }}</span>
      <div class="balance-values">
        <span>{{ change.balanceType }}（前）：{{ amount(change.balanceBefore) }}</span>
        <span>变动金额：{{ amount(change.amount) }}</span>
        <span>{{ change.balanceType }}（后）：{{ amount(change.balanceAfter) }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { orderBalanceTitle, visibleOrderBalanceChanges } from '../utils/orderBalance.js';
import { formatDecimal } from '../utils/formatDecimal';

const props = defineProps({ changes: { type: Array, default: () => [] } });
const visibleChanges = computed(() => visibleOrderBalanceChanges(props.changes));
function amount(value) { return value === '' || value == null ? '—' : formatDecimal(value); }
</script>
<style scoped>
.order-balance-details { width:100%; display:flex; flex-direction:column; gap:8px; padding:12px; border-radius:10px; background:#f4f7fb; color:#626a7b; font-size:12px; line-height:1.7; }
.balance-section-title { margin:0; color:#405873; font-size:12px; font-weight:600; }
.balance-stage { padding:8px 10px; border-radius:7px; background:#fff; }
.balance-title { display: block; font-weight: 600; }
.balance-values { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 16px; }
.balance-values > span { white-space: nowrap; }
.balance-empty { color:#8796aa; }
</style>
